import { useState } from 'react';


const ReplaceTextTool = () => {
  const [text, setText] = useState('');
  const [find, setFind] = useState('');
  const [replace, setReplace] = useState('');
  const [result, setResult] = useState('');

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleFindChange = (e) => {
    setFind(e.target.value);
  };

  const handleReplaceChange = (e) => {
    setReplace(e.target.value);
  };

  const handleReplace = () => {
    const newText = text.replace(new RegExp(find, 'g'), replace);
    setResult(newText);
  };


  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label


  const handleCopy = () => {
    navigator.clipboard.writeText(result);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };



  const handleClear = () => {
    setText('');
    setFind('');
    setReplace('');
    setResult('');
  };
  
     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">

  <div className="form-group mb-3">
    <textarea
      className="form-control"
      value={text}
      onChange={handleTextChange}
      style={{ height: '10rem' }}
      placeholder="Enter text..."
      rows="5"
    />
  </div>

  <div className="row mb-3">
    <div className="col-md-6 mb-2">
      <input
        className="form-control"
        value={find}
        onChange={handleFindChange}
        placeholder="Find..."
      />
    </div>
    <div className="col-md-6">
      <input
        className="form-control"
        value={replace}
        onChange={handleReplaceChange}
       
        placeholder="Replace"
      />
    </div>
  </div>
  

  <button className="btn btn-primary" onClick={handleReplace}>
  Replace
  </button>
  

  <div className="form-group mb-3">
    <textarea
      className="form-control"
      value={result}
      style={{ height: '10rem' }}
      readOnly
      rows="5"
    />
  </div>
  <div className="d-flex align-items-center">


  <button className="btn btn-primary" onClick={handleCopy}>
  {copyButtonLabel}
  </button>
  <button
        className="btn btn-danger "
        onClick={handleClear}
      >
     Clear
      </button>
</div>
<div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
</div>

  );
};

export default ReplaceTextTool;